import { List as ImmutableList } from 'immutable';
import { AGGREGATION, TIME_SERIES } from 'reporting-data/constants/configTypes';
import { isDateOrDateTime } from 'reporting-data/properties/propertyUtils';
const DEFAULT_DIMENSION = 'date';
const updateReport = (report, newEvent, eventProperties) => {
  const newEventProperties = eventProperties[newEvent];
  const newEventPropertyKeys = [...newEventProperties.keys()];
  return report.withMutations(mutableReport => mutableReport.update('config', config => {
    const oldDimensions = config.get('dimensions');
    const validDimensions = oldDimensions.filter(dimension => newEventPropertyKeys.includes(dimension));
    const newDimensions = validDimensions.length === 0 && oldDimensions.length > 0 ? ImmutableList([DEFAULT_DIMENSION]) : validDimensions;
    const configType = newDimensions.length > 0 && isDateOrDateTime(newEventProperties.get(newDimensions.get(0))) ? TIME_SERIES : AGGREGATION;
    return config.set('unifiedEventTypeName', newEvent).set('dimensions', newDimensions).set('configType', configType);
  }).updateIn(['displayParams', 'dataColumns'], dataColumns => dataColumns && dataColumns.filter(dataColumn => newEventPropertyKeys.includes(dataColumn))));
};
export default updateReport;